import { render } from "./Metrics.vue?vue&type=template&id=5f48a5e5&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=5f48a5e5&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f48a5e5"]])

export default __exports__